import { render, staticRenderFns } from "./ConsumerDashboardPostpaid.vue?vue&type=template&id=44eaf7c0&scoped=true&"
import script from "./ConsumerDashboardPostpaid.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardPostpaid.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardPostpaid.vue?vue&type=style&index=0&id=44eaf7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eaf7c0",
  null
  
)

export default component.exports